import { useState } from 'react';
import { apiFetch } from '@/lib/supabase';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';

export default function ProductCreateDialog({ open, onClose, collections, onCreated }) {
  const [form, setForm] = useState({ product_sku:'', name:'', brand:'Velvet Bloom Flowers', category:'', occasion:'', current_price:'', collection_id:'', catalog_base:'' });
  const [busy, setBusy] = useState(false);
  const set = k => e => setForm({ ...form, [k]: e.target ? e.target.value : e });

  const submit = async () => {
    if (!form.product_sku.trim() || !form.name.trim()) return toast.error('SKU and name required');
    setBusy(true);
    try {
      await apiFetch('/catalog/products', {
        method: 'POST',
        body: JSON.stringify({
          ...form,
          current_price: form.current_price === '' ? null : Number(form.current_price),
          collection_id: form.collection_id || null,
        }),
      });
      toast.success(`${form.name} created as draft`);
      setForm({ product_sku:'', name:'', brand:'Velvet Bloom Flowers', category:'', occasion:'', current_price:'', collection_id:'', catalog_base:'' });
      onCreated?.(); onClose();
    } catch (e) { toast.error(e.message); }
    setBusy(false);
  };

  return (
    <Dialog open={open} onOpenChange={v => !v && onClose()}>
      <DialogContent className="max-w-lg rounded-sm" data-testid="new-product-dialog">
        <DialogHeader><DialogTitle className="font-serif text-3xl tracking-tight">New product</DialogTitle></DialogHeader>
        <div className="space-y-4 pt-2">
          <div className="grid grid-cols-2 gap-3">
            <div>
              <Label>Product SKU</Label>
              <Input value={form.product_sku} onChange={set('product_sku')} className="rounded-sm font-mono" placeholder="e.g. VB-031" data-testid="new-sku-input" />
            </div>
            <div>
              <Label>Selling price (optional)</Label>
              <Input type="number" step="0.01" value={form.current_price} onChange={set('current_price')} className="rounded-sm" placeholder="Leave blank if pending" data-testid="new-price-input" />
            </div>
          </div>
          <div>
            <Label>Name</Label>
            <Input value={form.name} onChange={set('name')} className="rounded-sm" data-testid="new-name-input" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <Label>Collection</Label>
              <Select value={form.collection_id} onValueChange={set('collection_id')}>
                <SelectTrigger className="rounded-sm" data-testid="new-collection-select"><SelectValue placeholder="Select…" /></SelectTrigger>
                <SelectContent>
                  {(collections || []).filter(c => !c.is_archived).map(c => (
                    <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label>Occasion / Season</Label>
              <Input value={form.occasion} onChange={set('occasion')} className="rounded-sm" />
            </div>
          </div>
          <p className="text-xs text-muted-foreground">Created as a Draft — hidden from sales until a recipe version is Approved &amp; Activated.</p>
        </div>
        <DialogFooter>
          <Button variant="outline" className="rounded-sm" onClick={onClose}>Cancel</Button>
          <Button disabled={busy} onClick={submit} className="rounded-sm bg-foreground text-background hover:bg-foreground/90" data-testid="save-new-product">Create draft</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
